"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = exports.removeDead = exports.killAll = exports.kill = exports.create = exports.createMultiple = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var diveParticlesData_sidecar_1 = require("./diveParticlesData-sidecar");
var defaultScale = 1; // 0.25
var objs = [];
var getAll = function () {
    return objs;
};
exports.getAll = getAll;
function createMultiple(type, x, y, numParticles, tint) {
    for (var i = 0; i < numParticles; i++) {
        create(type, x, y, tint);
    }
}
exports.createMultiple = createMultiple;
function create(type, x, y, tint) {
    var id = -1; // createId()
    var data = diveParticlesData_sidecar_1.diveParticlesData.get(type);
    // TODO: switch to a recycler?
    var layer = voyageLayers_sidecar_1.voyageLayers.getLayers().particles;
    var frame = data.frames[0];
    if (!data.playFrames) {
        frame = rando_sidecar_1.rando.sample(data.frames);
    }
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(layer, frame);
    var ox = rando_sidecar_1.rando.f(data.offsetXrange[0], data.offsetXrange[1]);
    var oy = rando_sidecar_1.rando.f(data.offsetYrange[0], data.offsetYrange[1]);
    x += ox;
    y += oy;
    image.x = x;
    image.y = y;
    var minTime = data.minTimeSeconds || data.maxTimeSeconds * 0.5;
    var timeMax = rando_sidecar_1.rando.f(minTime, data.maxTimeSeconds);
    var obj = {
        eType: 'particle',
        data: data,
        isDead: false,
        id: id,
        idLoaded: 0,
        image: image,
        fade: false,
        shrink: data.shrink,
        dirX: rando_sidecar_1.rando.f(data.dirXrange[0], data.dirXrange[1]),
        dirY: rando_sidecar_1.rando.f(data.dirYrange[0], data.dirYrange[1]),
        speed: 100,
        decelerate: false,
        timeElapsed: 0,
        timeMax: timeMax,
        x: x,
        y: y,
        frameTimer: 0,
        frameIdx: 0,
        sineXoffset: rando_sidecar_1.rando.f(0, Math.PI * 2),
    };
    image.flipX = rando_sidecar_1.rando.b();
    image.tint = tint;
    spritesUtil_sidecar_1.spritesUtil.scale(image, data.scale * defaultScale);
    if (data.afterCreate) {
        data.afterCreate(obj);
    }
    // if (type === 'rain') {
    //   obj.dirX = 0
    //   obj.dirY = 1
    // }
    update(obj, true);
    objs.push(obj);
    return obj;
}
exports.create = create;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.image.destroy();
    });
}
exports.removeDead = removeDead;
function updateAll() {
    objs.forEach(function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function update(obj, firstUpdate) {
    if (firstUpdate === void 0) { firstUpdate = false; }
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (firstUpdate) {
        ds = 0;
    }
    // let max = 0.01
    // if (d > max) {
    //   d = max
    // }
    var timeLeftFactor = 1 - obj.timeElapsed / obj.timeMax;
    if (timeLeftFactor < 0) {
        timeLeftFactor = 0;
    }
    if (obj.fade) {
        obj.image.alpha = timeLeftFactor;
    }
    if (obj.shrink) {
        spritesUtil_sidecar_1.spritesUtil.scale(obj.image, timeLeftFactor * obj.data.scale * defaultScale);
    }
    var curSpeed = obj.speed;
    if (obj.decelerate) {
        curSpeed = obj.speed * 1 - timeLeftFactor;
    }
    var speed = curSpeed * ds;
    var dx = obj.dirX * speed;
    var dy = obj.dirY * speed;
    if (obj.data.playFrames) {
        var frameRate = obj.timeMax / obj.data.frames.length;
        obj.frameTimer += ds;
        if (obj.frameTimer > frameRate) {
            obj.frameTimer -= frameRate;
            obj.frameIdx++;
            if (obj.frameIdx >= obj.data.frames.length) {
                kill(obj);
                return;
            }
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.image, obj.data.frames[obj.frameIdx]);
        }
    }
    obj.dirY += -obj.data.accelY * ds;
    obj.x += dx;
    obj.y += dy;
    obj.image.x = obj.x;
    obj.image.y = obj.y;
    if (obj.data.sineX) {
        obj.image.x +=
            obj.data.sineX *
                Math.sin(common_sidecar_1.common.getElapsedTime() * obj.data.sineXperiod + obj.sineXoffset);
    }
    obj.timeElapsed += ds;
    if (obj.timeElapsed > obj.timeMax) {
        kill(obj);
    }
}
